/* import __COLOCATED_TEMPLATE__ from './column-selector.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ColumnSelectorComponent extends Component {
  @tracked isOpen = false;

  @action
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.isOpen = true;
      // Add listeners when opening
      document.addEventListener('keydown', this.handleKeydown);
      // Delay adding click listener to avoid immediate close from the toggle click
      setTimeout(() => {
        document.addEventListener('click', this.handleClickOutside);
      }, 0);
    }
  }

  @action
  toggleColumn(columnName) {
    this.args.onToggle(columnName);
  }

  @action
  close() {
    this.isOpen = false;
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleClickOutside);
  }

  @action
  handleKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
    }
  }

  @action
  handleClickOutside(event) {
    // Check if click is outside the dropdown
    const dropdown = document.querySelector('.column-selector-dropdown');
    const button = document.querySelector('.column-selector button');
    if (dropdown && !dropdown.contains(event.target) && !button?.contains(event.target)) {
      this.close();
    }
  }

  willDestroy() {
    super.willDestroy(...arguments);
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleClickOutside);
  }
}
